import {
  m6 as objectMeta,
  ga as VOID,
  o6 as setMetadataFor,
  p5 as classMeta,
  r9 as RuntimeException,
  j5 as captureStack,
  h2 as emptyList,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class Companion {
  constructor() {
    Companion_instance = this;
  }
  j4h(primitiveKlass, rawKlass, toRaw, toPrimitive) {
    return new PrimitiveMapper(primitiveKlass, rawKlass, toRaw, toPrimitive);
  }
}
class PrimitiveMapper {
  constructor(primitiveKlass, rawKlass, toRaw, toPrimitive) {
    Companion_getInstance();
    this.k4h_1 = primitiveKlass;
    this.l4h_1 = rawKlass;
    this.m4h_1 = toRaw;
    this.n4h_1 = toPrimitive;
  }
}
class KompositeException extends RuntimeException {
  static s4h(message, issues, cause) {
    var $this = super.ug(message, cause);
    captureStack($this, $this.r4h_1);
    $this.q4h_1 = issues;
    return $this;
  }
  static t4h(message) {
    var $this = this.s4h(message, emptyList(), null);
    return $this;
  }
  static u4h(message, cause) {
    var $this = this.s4h(message, emptyList(), cause);
    return $this;
  }
}
//endregion
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new Companion();
  return Companion_instance;
}
//region block: post-declaration
setMetadataFor(Companion, 'Companion', objectMeta);
setMetadataFor(PrimitiveMapper, 'PrimitiveMapper', classMeta);
setMetadataFor(KompositeException, 'KompositeException', classMeta);
//endregion
//region block: exports
export {
  Companion_getInstance as a,
  KompositeException as b,
  PrimitiveMapper as c,
};
//endregion

//# sourceMappingURL=net.akehurst.kotlin.komposite-komposite-api.mjs.map
